export const getters = {
  user: state => state.user.user,
  permission: state => state.permission.permission,
  sidebar: state => state.app.sidebar,
  device: state => state.app.device
}